import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITerminationReason } from "src/models/HumanResources/TerminationReasons.models";

interface TerminationReasonState {
  terminationReasons: ITerminationReason[];
  terminationReasonToEdit: ITerminationReason | null;
}

const initialState: TerminationReasonState = {
  terminationReasons: [],
  terminationReasonToEdit: null,
};

const TerminationReasonSlice = createSlice({
  name: "TerminationReason",
  initialState,
  reducers: {
    setTerminationReasonList: (
      state,
      action: PayloadAction<ITerminationReason[]>
    ) => {
      state.terminationReasons = action.payload;
    },
    concatListTerminationReason: (
      state: TerminationReasonState,
      action: PayloadAction<ITerminationReason[]>
    ) => {
      state.terminationReasons = [
        ...state.terminationReasons.concat(action.payload),
      ];
    },
    setTerminationReasonToEdit: (
      state,
      action: PayloadAction<ITerminationReason | null>
    ) => {
      state.terminationReasonToEdit = action.payload;
    },
    addTerminationReason: (
      state,
      action: PayloadAction<ITerminationReason>
    ) => {
      state.terminationReasons.push(action.payload);
    },
    updateTerminationReason: (
      state,
      action: PayloadAction<ITerminationReason>
    ) => {
      let itemIndex = state.terminationReasons.findIndex(
        item => item.terminationReasonId === action.payload.terminationReasonId
      );
      if (itemIndex !== -1)
        state.terminationReasons[itemIndex] = action.payload;
    },
    deleteTerminationReason: (state, action: PayloadAction<number>) => {
      const newArray = state.terminationReasons.filter(
        item => item.terminationReasonId !== action.payload
      );
      state.terminationReasons = newArray;
    },
  },
});

export const {
  setTerminationReasonList,
  concatListTerminationReason,
  setTerminationReasonToEdit,
  addTerminationReason,
  updateTerminationReason,
  deleteTerminationReason,
} = TerminationReasonSlice.actions;

export default TerminationReasonSlice.reducer;
